import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './pages/home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import AboutUs from './pages/aboutUs';
import Products from './pages/product';
import Services from './pages/service';
import ContactUs from './pages/contact';

import Label from './components/label';

function App() {
  return (
    <Router>
      <Label />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/products" element={<Products />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<ContactUs />} />

    </Routes>
    <Footer />
  </Router>
  );
}

export default App;
